import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./todosReducer";

export default configureStore({
  reducer: {
    counter: counterReducer
  }
});